import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// Simplified from Natural Earth's public-domain province boundaries:
// https://www.naturalearthdata.com/about/terms-of-use/
// Vancouver Island and the Graham Island mark are enlarged and separated
// from the coast for legibility at 20px.
export default function BritishColumbiaIcon(props) {
    return <SvgIcon {...props}>
        <g fill="currentColor">
            <path d="M2 4.05h15.24l.09 8.83 1.33 1.54 1.24.81 1.35 1.69.74 2.11h-7.22l-.47-1.43-1.2-1.2-1.1-.2-1.3-1.4-.2-1.7-1.4-.6.2-3.1-1.42-.7-1.28-2.48L5.2 4.63 3.29 5.55Z" />
            <path d="m8.85 15.65 1.6.6 1.5 1.5 1.6 3-1.9-.7-1.9-1.8-1.4-2.5Z" />
        </g>
        <path d="m5.8 10.1 1 2.2" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </SvgIcon>;
}
